// Integration Cloud - Orbiting logos
export const IntegrationCloud = () => (
  <div className="relative w-full h-full min-h-[120px] flex items-center justify-center">
    {/* Center hub */}
    <div className="relative z-10 w-12 h-12 rounded-full bg-secondary/20 flex items-center justify-center">
      <div className="w-6 h-6 rounded-full bg-secondary animate-bento-pulse" />
    </div>

    {/* Orbiting logos */}
    <div className="absolute inset-0 flex items-center justify-center">
      {/* Google */}
      <div className="absolute -left-2 top-1/2 -translate-y-1/2 animate-bento-float">
        <div className="w-8 h-8 rounded-lg bg-white shadow-md flex items-center justify-center">
          <span className="text-sm font-bold text-blue-500">G</span>
        </div>
      </div>

      {/* Stripe */}
      <div className="absolute -right-2 top-1/2 -translate-y-1/2 animate-bento-float-delayed">
        <div className="w-8 h-8 rounded-lg bg-indigo-600 shadow-md flex items-center justify-center">
          <span className="text-sm font-bold text-white">S</span>
        </div>
      </div>

      {/* Canva */}
      <div className="absolute left-1/2 -translate-x-1/2 -top-2 animate-bento-float-alt">
        <div className="w-8 h-8 rounded-lg bg-cyan-500 shadow-md flex items-center justify-center">
          <span className="text-sm font-bold text-white">C</span>
        </div>
      </div>

      {/* Dotypos */}
      <div className="absolute left-1/2 -translate-x-1/2 -bottom-2 animate-bento-float">
        <div className="w-8 h-8 rounded-lg bg-orange-500 shadow-md flex items-center justify-center">
          <span className="text-sm font-bold text-white">D</span>
        </div>
      </div>
    </div>

    {/* Connection lines */}
    <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-30" preserveAspectRatio="xMidYMid meet">
      <circle cx="50%" cy="50%" r="35%" fill="none" stroke="var(--secondary-hex)" strokeWidth="1" strokeDasharray="4 4" />
    </svg>
  </div>
);
